// extracted by mini-css-extract-plugin
export default {"root":"styles__root--6Y9ro","toggle":"styles__toggle--Ds63d"};